import { IniSection } from './ini';
import { parseBgrString } from './KnyttUtil';

/** Parsed [World] section metadata. */
export class KnyttWorldInfo {
  name: string;
  author: string;
  description: string;
  size: string;
  difficulties: string[] = [];
  categories: string[] = [];
  format: number;
  clothes: number;
  skin: number;
  character: string | null;

  constructor(world: IniSection | null) {
    const get = (k: string): string | null => (world ? world.get(k) : null);
    this.name = get('Name') ?? 'Untitled';
    this.author = get('Author') ?? 'Unknown';
    this.description = get('Description') ?? '';
    this.size = get('Size') ?? '';
    const format = Number.parseInt(get('Format') ?? '', 10);
    this.format = Number.isNaN(format) ? 2 : format;
    this.clothes = parseBgrString(get('Clothes'), -1);
    this.skin = parseBgrString(get('Skin'), -1);
    this.character = get('Character');

    for (const s of ['A', 'B']) {
      const v = get(`Category ${s}`);
      if (v != null) this.categories.push(v);
    }
    for (const s of ['A', 'B', 'C']) {
      const v = get(`Difficulty ${s}`);
      if (v != null) this.difficulties.push(v);
    }
  }
}
